import { DashboardResources } from '@src/types';
import {
  Toolbar,
  SaveButton,
  CanAccess,
} from 'react-admin';

const CatalogEditToolbar = () => (
  <Toolbar>
    <CanAccess resource={DashboardResources.CatalogItems} action="edit">
      <SaveButton />
    </CanAccess>
  </Toolbar>
);

export default CatalogEditToolbar;
